import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FirebaseService } from '../../../../common/firebase/firebase.service';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {

  private http = inject(HttpClient);
  private firebaseService = inject(FirebaseService);

  getMyToDoList(since?: string, businessAccountId?: string): Observable<MyToDoListResponseDto> {
    let params = new HttpParams();
    if (since != null) params = params.set('since', since);
    if (businessAccountId != null) params = params.set('businessAccountId', businessAccountId);

    const url = `${environment.shout_api.url}/dashboard/my-todo`;
    return this.http.get<MyToDoListResponseDto>(url, { params });
  }

  getActivityStats(businessAccountId?: string): Observable<ActivityStatsResponseDto> {
    let params = new HttpParams();
    if (businessAccountId != null) params = params.set('businessAccountId', businessAccountId);

    const url = `${environment.shout_api.url}/dashboard/activity-stats`;
    return this.http.get<ActivityStatsResponseDto>(url, { params });
  }

  getTopLineStats(businessAccountId?: string, lastVisit?: Date | null): Observable<TopLineStatsResponseDto> {
    let params = new HttpParams();
    if (businessAccountId != null) params = params.set('businessAccountId', businessAccountId);
    if (lastVisit != null) params = params.set('lastVisit', lastVisit.toISOString());

    const url = `${environment.shout_api.url}/dashboard/top-line-stats`;
    return this.http.get<TopLineStatsResponseDto>(url, { params });
  }
}

export interface MyToDoItemDto {
  id: string;
  taskType: string;
  title: string;
  description?: string;
  priority: 'high' | 'medium' | 'low';
  createdAt: string;
  deepLinkPath: string;
}

export interface MyToDoListResponseDto {
  tasks: MyToDoItemDto[];
}

export interface PeriodStatDto {
  current: number;
  previous: number;
  percentageChange: number | null;
}

export interface VideoStatDto {
  currentTotal: number;
  currentStatus3: number;
  previousTotal: number;
  previousStatus3: number;
  percentageChange: number | null;
}

export interface ActivityStatsResponseDto {
  briefs: PeriodStatDto;
  hiredCreators: PeriodStatDto;
  videos: VideoStatDto;
  videoViews: PeriodStatDto | null;
}

export interface TopLineStatsResponseDto {
  allActiveBriefs: number;
  applicationsApplied: number;
  applicationsHiredOrStarted: number;
  applicationsReadyToPost: number;
  allActiveBriefsChange: number;
  applicationsAppliedChange: number;
  applicationsHiredOrStartedChange: number;
  applicationsReadyToPostChange: number;
}